import { useContext } from 'react'
import { SessionContext } from './contexts.js'

// Role/session state under the same names the legacy realtime hook exposed:
//   { isConnected, isAdmin, isSeller, authrole, authextra,
//     needsUsername, clearNeedsUsername, status }
// plus: { me, refetchSession, error } — see SessionProvider.jsx for semantics.
export function useSession() {
  const ctx = useContext(SessionContext)
  if (!ctx) throw new Error('useSession must be used within SessionProvider')
  return ctx
}
